import {concat, defer, EMPTY, Observable, OperatorFunction} from 'rxjs';
import {exhaustMap, tap} from 'rxjs/operators';

/** An exhaustMap that behaves like a throttle with both leading and trailing edges. */
export function exhaustMapTrailing<T, U>(project: (value: T) => Observable<U>): OperatorFunction<T, U> {
  return (source$) => {
    let pendingEmit: {value: T} | undefined;

    // This keeps projecting values until there is no pending emissions.
    const pendingEmits$: Observable<U> = defer(() => {
      if (!pendingEmit) {
        return EMPTY;
      }

      const {value} = pendingEmit;
      pendingEmit = undefined;

      return concat(project(value), pendingEmits$);
    });

    return source$.pipe(
      tap((x) => {
        // We only care about the last pending emission.
        pendingEmit = {value: x};
      }),
      exhaustMap(() => pendingEmits$),
    );
  };
}
